/**
 * contactCategoryApi.js
 * ---------------------
 * API client for Contact Category Master (ContactCategory) using createMasterApiClient.
 * Connects directly to FastAPI backend /contact-category/ endpoints.
 * 100% conforming to module_implementation_standards.md.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const contactCategoryClient = createMasterApiClient('contact-category');

export const listContactCategories = (params) => contactCategoryClient.list(params);
export const getContactCategoryDetail = (id) => contactCategoryClient.getById(id);
export const createContactCategory = (data) => contactCategoryClient.create(data);
export const updateContactCategory = (id, data) => contactCategoryClient.update(id, data);
export const archiveContactCategory = (id) => contactCategoryClient.archive(id);
export const deleteContactCategory = (id) => contactCategoryClient.remove(id);
export const getContactCategoryOptions = () => contactCategoryClient.getDropdownOptions();
